<template>
  <div>
    <div class="form_wrapper">
    <img class="logo" src="/logo.svg">
 
    <div id="contenu" class="infosbrowser">
        <div>Systéme d'exploitation : {{ os }}</div>
        <div>Résolution écran : {{ screen }}</div>        
        <div>Navigateur : {{ navigator }}</div>
        <div>Résolution Navigateur : {{ navigator_resolution }}</div>  
        <div>
          <br /><br />
   
        </div>    
    </div>
    </div></div>
</template>
<script>
export default {
    mounted() {

            if (navigator.appVersion.indexOf("Win") != -1) this.os = "Windows";
            if (navigator.appVersion.indexOf("Mac") != -1) this.os = "MacOS";
            if (navigator.appVersion.indexOf("X11") != -1) this.os = "UNIX";
            if (navigator.appVersion.indexOf("Linux") != -1) this.os = "Linux";
            this.screen = window.screen.width + 'x' + window.screen.height;
            this.navigator_resolution = window.innerWidth + 'x' + window.innerHeight;
            
            navigator.sayswho = (function () {
                var ua = navigator.userAgent,
                    tem,
                    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if (/trident/i.test(M[1])) {
                    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                    return 'IE ' + (tem[1] || '');
                }
                if (M[1] === 'Chrome') {
                    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
                }
                M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
                return M.join(' ');
            })();

            this.navigator = navigator.sayswho; 




        },
        name: "form",
        methods : {

        },
        data: function () {
            return {
                os: "Unknown OS",
                screen: undefined,
                navigator: undefined,
                navigator_resolution: undefined,
            };
        },

    }
</script>
<style lang="scss">
.infosbrowser {
    width: fit-content;
    margin:0 auto;
    
    div {
        text-align: left;
    }
    
}
</style>